import React from 'react';
import { Button, Form } from 'tea-component';
import { isSubVersion } from '@op/utils/game';
import BubbleCommon, {
  gptSubGameNotSupportTipsText,
} from '@op/components/BubbleCommon';
import useLanguage from '@op/hooks/useLanguage';
import StopIcon from '@op/assets/svg/stop-circle.svg';

interface CommonFormButtonsProps {
  gameInfo: any;
  loading: boolean;
  confirmDisabled: boolean;
  saveDisabled: boolean;
  saveName: string;
  showEmailMessage: boolean;
  isSave: boolean;
  onGenerate?: () => void;
  onReset?: () => void;
  onSave?: () => void;
  onStop?: () => void;
  extraLoading?: boolean;
  showRegularListening?: () => void;
  tabType: 'keyword' | 'topic' | 'url';
}

/**
 * 提取共同的表单按钮组件
 */
export default function CommonFormButtons({
  gameInfo,
  loading,
  confirmDisabled,
  saveDisabled,
  saveName,
  showEmailMessage,
  isSave,
  onGenerate,
  onReset,
  onSave,
  onStop,
  extraLoading = false,
  showRegularListening,
  tabType,
}: CommonFormButtonsProps) {
  const { formatMessage } = useLanguage();

  return (
    <Form.Item className="dbo-keywords-analysis-form-btns">
      <BubbleCommon
        showIcon={false}
        placement="top"
        tipsMap={
          isSubVersion(gameInfo) ? gptSubGameNotSupportTipsText : undefined
        }
      >
        {(loading || extraLoading) && tabType === 'topic' ? (
          <Button
            className="dbo-btn-item dbo-btn-stop"
            type="primary"
            onClick={onStop}
          >
            <img src={StopIcon} className="dbo-stop-icon" />
            {formatMessage({ id: 'Stop' })}
          </Button>
        ) : (
          <Button
            className="dbo-btn-item"
            type="primary"
            loading={loading || extraLoading}
            disabled={
              confirmDisabled ||
              isSubVersion(gameInfo) ||
              (isSave && (!saveName.trim() || showEmailMessage))
            }
            onClick={onGenerate}
          >
            {formatMessage({ id: 'Generate Analysis' })}
          </Button>
        )}
      </BubbleCommon> 
      {tabType !== 'url' && (
        <Button
          className="dbo-btn-item"
          disabled={confirmDisabled}
          onClick={() => showRegularListening?.()}
        >
          {formatMessage({ id: 'Regular Listening' })}
        </Button>
      )}
      <Button className="dbo-btn-item" onClick={onReset}>
        {formatMessage({ id: 'Reset' })}
      </Button>
      <Button
        disabled={saveDisabled || confirmDisabled}
        className="dbo-btn-item"
        onClick={onSave}
      >
        {formatMessage({ id: 'Save Filter Setting' })}
      </Button>
    </Form.Item>
  );
}
